<template lang="pug">
  el-form(
    :model="form"
    :rules="rules"
    label-width="150px"
  )

    title-bar(style="margin-bottom: 20px") {{ $t('② 联系人信息') }}

    el-form-item(:label="$t('登录邮箱')" prop="mail")
      el-input(v-model="form.mail" :disabled="true")

    el-form-item(:label="$t('联系人姓名')" prop="user_name")
      el-input(v-model="form.user_name" :disabled="true")

    el-form-item(:label="$t('性别')" prop="gender")
      el-radio(v-model="form.gender" :label="1" :disabled="true") {{ $t('男') }}
      el-radio(v-model="form.gender" :label="0" :disabled="true") {{ $t('女') }}

    el-form-item(:label="$t('职位')" prop="position")
      el-input(v-model="form.position" :disabled="true")

    el-form-item(:label="$t('手机')" prop="phone_mobile")
      el-input(v-model="form.phone_mobile" :disabled="true")

    el-form-item(:label="$t('座机')" prop="phone_office")
      el-input(v-model="form.phone_office" :disabled="true")
</template>

<script>
import TitleBar from '@/components/TitleBar'

export default {
  components: {
    TitleBar
  },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      form: {
        mail: '',
        user_name: '',
        gender: 1,
        position: '',
        phone_mobile: '',
        phone_office: ''
      },
      rules: {
        mail: [ { required: true, message: '请输入登录邮箱', trigger: 'blur' } ],
        user_name: [ { required: true, message: '请输入联系人姓名', trigger: 'blur' } ],
        gender: [ { required: true } ],
        position: [ { required: true, message: '请输入职位', trigger: 'blur' } ],
        phone_mobile: [ { required: true, message: '请输入手机', trigger: 'blur' } ]
      }
    }
  },
  watch: {
    data () {
      this.form = Object.keys(this.form).reduce((pre, cur) => {
        pre[cur] = this.data[cur]
        return pre
      }, {})
    }
  },
  methods: {
    submit () {
      return this.form
    }
  }
}
</script>
